<template>
  <mia-labelled-text
    label="Kommissionsnummer"
    class="relative"
  >
    <span
      v-clipboard="commissionNumber"
      v-clipboard:success="showClipboardNotification"
      :class="{ 'cursor-pointer hover:bg-gray-400': commissionNumber }"
    >
      {{ commissionNumber || '-' }}
    </span>

    <transition
      enter-class="opacity-0"
      enter-active-class="transition-opacity duration-500 ease-out-fast"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition-opacity duration-500 ease-out-fast"
      leave-to-class="opacity-0"
    >
      <div
        v-if="showNotification"
        class="absolute px-4 py-2 mt-2 -ml-2 text-base text-white whitespace-no-wrap rounded-full shadow-xl bg-orange-mia"
      >
        Kommissionsnummer kopiert!
      </div>
    </transition>
  </mia-labelled-text>
</template>

<script>
import LabelledText from '@/components/cars/edit/LabelledText.vue'

export default {
  name: 'MiaClipboardCommissionNumber',

  components: {
    'mia-labelled-text': LabelledText
  },

  props: {
    commissionNumber: {
      required: true,
      validator: value => typeof value === 'string' || value === null
    }
  },

  data: () => ({
    showNotification: false
  }),

  beforeDestroy() {
    if (this.notificationTimer) {
      window.clearTimeout(this.notificationTimer)
    }

    this.showNotification = false
  },

  methods: {
    showClipboardNotification() {
      if (this.notificationTimer) {
        window.clearTimeout(this.notificationTimer)
      }

      this.showNotification = true

      this.notificationTimer = window.setTimeout(() => {
        this.showNotification = false
      }, 2500)
    }
  }
}
</script>
